import { render, staticRenderFns } from "./myOrderDetails.vue?vue&type=template&id=5157222a&scoped=true&"
import script from "./myOrderDetails.vue?vue&type=script&lang=js&"
export * from "./myOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./myOrderDetails.vue?vue&type=style&index=0&id=5157222a&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5157222a",
  null
  
)

export default component.exports